<template>
    <div class="rd-list">
        <loading
            :active.sync="open_loader"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#6366f1'"
        ></loading>

        <header class="rd-list__head">
            <div>
                <h1 class="rd-list__title">Otvorene prijave</h1>
                <p class="rd-list__sub">Odaberite skup za prijavu.</p>
            </div>
            <router-link to="/" class="rd-back">← Natrag</router-link>
        </header>

        <div v-if="skupovi.length" class="rd-cards">
            <article
                v-for="(skup, index) in skupovi"
                :key="index"
                class="rd-card"
                @click.prevent="prijava(skup)"
            >
                <div class="rd-card__body rd-prose" v-html="skup.opis"></div>
                <div class="rd-card__foot">
                    <span class="rd-card__cta">Prijavi se →</span>
                </div>
            </article>
        </div>

        <div v-else-if="!open_loader" class="rd-empty">
            Trenutno nema otvorenih prijava.
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "toastr";
import moment from "moment";
export default {
name: "Prijave",
    components: {
        Loading,
    },
    data(){
        return {
            open_loader: false,
            app_owner: process.env.VUE_APP_APP_OWNER,
            skupovi: []
        }
    },
    methods:{
        init(){
            let vm=this
            vm.open_loader=true
            axios.get( process.env.VUE_APP_API_URL + 'skup', {
                params: {

                }
            } )
            .then( function ( response ) {
                console.log( response.data.data )
                vm.skupovi = response.data.data
                vm.open_loader = false;
            } )
            .catch( function ( error ) {
                vm.open_loader = false;
                if(error instanceof Error) {
                    console.log( 'Error: ' + error);
                } else {
                    console.log( 'Unexpected response: ' + error);
                }
            } )
        },
        prijava(  skup ){
            let vm = this
            vm.open_loader = false

            if( skup.vrsta_skupova && skup.vrsta_skupova.prijava_forma ){
                axios( {
                    method: 'GET',
                    url: process.env.VUE_APP_API_URL + 'prijava',
                    params: {
                        filters: {
                            skup_id: skup.id
                        }
                    }
                } )
                    .then( function( response ) {
                        vm.open_loader = false
                        if( response.data.results === 0 ){
                            vm.$router.push( 'prijave/' + skup.id + '/prijava')
                        } else {

                            let date1=moment( skup.datum_od, 'DD.MM.YYYY. HH:mm' )
                            let date2=moment( skup.datum_prijave_do, 'DD.MM.YYYY. HH:mm' )

                            if( date1.isBefore( date2) ){
                                toastr.error( 'Već ste prijavljeni. Nije moguće uređivati prijavu' )
                            } else {
                                vm.$router.push( 'prijave/' + skup.id + '/prijava/' + response.data.data[ response.data.data.length - 1 ].id )
                            }
                        }
                    } )
                    .catch( function ( response ) {
                        vm.open_loader = false
                        console.log( response )
                    } )
            } else if ( skup.vrsta_skupova && skup.vrsta_skupova.prilagodjena_forma ){

                if( process.env.VUE_APP_APP_OWNER === 'HKIG' && skup.id == '49'){
                    vm.$router.push( '/pravni-portal');
                }

                if( process.env.VUE_APP_APP_OWNER === 'HKIG' && skup.id == '50'){
                    vm.$router.push( '/webinari-15-dani');
                }
            } else if ( skup.vrsta_skupova && skup.vrsta_skupova.vanjska_poveznica ){
                window.location.href = JSON.parse( skup.poveznica.data )['redirect_to']
            }


        }
    },
    mounted() {
        this.init()
        this.interval = setInterval(() => this.init(), 500000);
    },
    beforeDestroy() {
        clearInterval( this.interval )
    }
}
</script>

<style scoped>
.rd-list__head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.75rem;
    flex-wrap: wrap;
}
.rd-list__title { font-size: 1.8rem; font-weight: 800; margin: 0; }
.rd-list__sub { color: var(--rd-muted, #6b7280); margin: .3rem 0 0; }

.rd-back {
    font-weight: 700;
    color: var(--rd-primary-600, #4f46e5);
    background: var(--rd-primary-50, #eef2ff);
    padding: .55rem 1.1rem;
    border-radius: 12px;
    transition: background .15s ease;
    white-space: nowrap;
}
.rd-back:hover { background: #e3e7ff; }

.rd-cards { display: flex; flex-direction: column; gap: 1.25rem; }

.rd-card {
    background: #fff;
    border: 1px solid var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px);
    box-shadow: var(--rd-shadow, 0 12px 28px -8px rgba(16,24,40,.14));
    padding: 1.75rem;
    cursor: pointer;
    transition: transform .15s ease, box-shadow .25s ease, border-color .2s ease;
}
.rd-card:hover {
    transform: translateY(-3px);
    box-shadow: var(--rd-shadow-lg, 0 24px 48px -12px rgba(31,28,86,.28));
    border-color: rgba(99,102,241,.45);
}

.rd-card__foot {
    margin-top: 1.25rem;
    padding-top: 1rem;
    border-top: 1px solid var(--rd-border, #e6e8f0);
    display: flex;
    justify-content: flex-end;
}
.rd-card__cta {
    font-weight: 700;
    color: #fff;
    background: var(--rd-gradient, linear-gradient(135deg, #6366f1, #7c3aed));
    padding: .5rem 1.1rem;
    border-radius: 12px;
    font-size: .9rem;
    box-shadow: 0 8px 18px -8px rgba(99,102,241,.7);
}

/* rich-text opis coming from the backend */
.rd-prose >>> img { max-width: 100%; height: auto; border-radius: 12px; }
.rd-prose >>> h1, .rd-prose >>> h2, .rd-prose >>> h3 { margin-top: 0; }
.rd-prose >>> table { width: 100%; }

.rd-empty {
    text-align: center;
    color: var(--rd-muted, #6b7280);
    background: #fff;
    border: 1px dashed var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px);
    padding: 3rem 1.5rem;
    font-size: 1.05rem;
}
</style>
